interface Props {
  shopName: string
  onOriginal: () => void
  onMorph: () => void
  onClose: () => void
}

export default function ViewerChoiceModal({ shopName, onOriginal, onMorph, onClose }: Props) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9000,
        background: 'rgba(0,0,0,0.75)',
        backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'rgba(20,20,30,0.95)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '16px',
          padding: '28px 24px',
          maxWidth: '420px',
          width: '100%',
          color: '#fff',
        }}
        onClick={e => e.stopPropagation()}
      >
        <h2 style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: 600 }}>
          {shopName}
        </h2>
        <p style={{ margin: '0 0 24px', fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>
          Choose how to view this shop
        </p>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={onOriginal}
            style={{
              flex: 1, padding: '16px 12px', borderRadius: '12px',
              background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)',
              color: '#fff', cursor: 'pointer', textAlign: 'left',
            }}
          >
            <div style={{ fontSize: '22px', marginBottom: '8px' }}>&#127981;</div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>Original Viewer</div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>Gesture navigation &amp; 3D point cloud</div>
          </button>
          <button
            onClick={onMorph}
            style={{
              flex: 1, padding: '16px 12px', borderRadius: '12px',
              background: 'rgba(74,160,255,0.12)', border: '1px solid rgba(74,160,255,0.35)',
              color: '#fff', cursor: 'pointer', textAlign: 'left',
            }}
          >
            <div style={{ fontSize: '22px', marginBottom: '8px' }}>&#10024;</div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>Morph Viewer</div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>Smooth frame morphing with WebGL</div>
          </button>
        </div>
        <button
          onClick={onClose}
          style={{
            marginTop: '16px', width: '100%', padding: '10px',
            background: 'transparent', border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px', color: 'rgba(255,255,255,0.4)',
            cursor: 'pointer', fontSize: '13px',
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
